module.exports = __webpack_public_path__ + "static/media/35-1.81d93da7.mp3";